/* eslint-disable import/no-extraneous-dependencies */
import { produce } from 'immer';
import { BLADES } from '../../constants';
import { VisibilityAction, VisibilityActionTypes } from './visibilityActions';

export interface Blade {
  /** used to show or hide the blade */
  display: boolean;
  /** used to tell the display logic if blade needs to displayed on update */
  required: boolean;
  /** used to indicate current active blade */
  hasFocus: boolean;
}

export const defaultBlade: Blade = {
  display: false,
  hasFocus: false,
  required: false,
};

export interface VisibilityState {
  [key: string]: Blade;
}

export const defaultVisibilityState: VisibilityState = {
  [BLADES.getStarted]: {
    ...defaultBlade,
    required: true,
  },
  [BLADES.yourDetails]: {
    ...defaultBlade,
    required: true,
  },
  [BLADES.accountDetails]: {
    ...defaultBlade,
    required: true,
  },
};

export const visibilityReducer = produce(
  (
    state: VisibilityState = defaultVisibilityState,
    action: VisibilityAction,
  ) => {
    switch (action.type) {
    case VisibilityActionTypes.BladeComplete: {
      state[BLADES.getStarted].display = true;
      return state;
    }

    case VisibilityActionTypes.BladesUpdate: {
      const bladeList = action.payload;
      const updatedBladeNames = Object.keys(bladeList);
      if (updatedBladeNames.length > 0) {
        updatedBladeNames.forEach((bladeName: string) => {
          state[bladeName] = bladeList[bladeName];
        });
      }
      return state;
    }

    case VisibilityActionTypes.BladeChangeFocus: {
      const bladeNames = Object.keys(state);
      // Remove focus from all blades
      bladeNames.forEach((blade: string) => {
        state[blade].hasFocus = false;
      });
      state[action.payload].hasFocus = true;
      return state;
    }

    case VisibilityActionTypes.BladeChangeDisplay: {
      const blades = Object.keys(state);
      const bladeIndex = blades.indexOf(action.payload);
      const nextBlades = blades.slice(bladeIndex + 1);
      // Remove focus from all blades
      nextBlades.forEach((blade: string) => {
        state[blade].hasFocus = false;
        state[blade].display = false;
      });
      state[action.payload].hasFocus = true;
      state[action.payload].display = true;
      return state;
    }

    default:
      return state;
    }
  },
);
